/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { Intent, Toaster } from '@blueprintjs/core';
import TritonAPI from 'AppModules/Triton/API/TritonAPI';
import DownloadData from './DownloadData';
import './DownloadData.css';

const dataToaster = Toaster.create();

const DownLoadDataContainer = (props) => {
  const token = useSelector((store) => store.authReducer.token || '');

  const [downloadProgress, setDownloadProgress] = React.useState();

  // Get pre-signed S3 link for full db file
  const dataFileQuery = useQuery([`${props.mainFile}_mainFileLink`], () => TritonAPI.getS3PresignedLink(token, props.mainFile));
  const runDetailsFileQuery = useQuery([`${props.runDetailsFile}runDetailsFileLink`], () => TritonAPI.downloadRunDetails(token, props.runDetailsFile));
  const dataUpToDate = !(new Date(runDetailsFileQuery.isSuccess && runDetailsFileQuery.data.runDetails.lastDate) > new Date(props.localLastDate));
  // console.log(' lastDate: ', runDetailsFileQuery?.data?.runDetails?.lastDate);

  const handleDownloadData = async () => {
    // eslint-disable-next-line no-unused-vars
    let isSubscribed = true; // needed because the async function could resolve after the component has unmounted

    setDownloadProgress(0); // Set progress to show that download has started (instead of waiting for the first progress event)
    try {
      const onDownloadProgress = (progressEvent) => setDownloadProgress(progressEvent.loaded / progressEvent.total);
      const data = await TritonAPI.downloadData(token, props.mainFile, onDownloadProgress);
      props.onDataDownLoaded(data);
    } catch (err) {
      dataToaster.show({ message: `Error downloading the data file: ${err.message}`, intent: Intent.DANGER, icon: 'warning-sign' });
    } finally {
      setDownloadProgress(null);
    }
    return () => {
      isSubscribed = false;
    };
  };

  return (
    <DownloadData
      downloadProgress={downloadProgress}
      dataStatus={props.dataStatus}
      dataUpToDate={dataUpToDate}
      handleDownloadData={handleDownloadData}
      dataFileQuery={dataFileQuery}
      runDetailsFileQuery={runDetailsFileQuery}
      showDLButton={process.env.REACT_APP_STAGE !== 'production' && props.showDLButton}
    />
  );
};

DownLoadDataContainer.propTypes = {
  mainFile: PropTypes.string.isRequired,
  runDetailsFile: PropTypes.string.isRequired,
  localLastDate: PropTypes.string,
  onDataDownLoaded: PropTypes.func.isRequired,
  dataStatus: PropTypes.string.isRequired,
  showDLButton: PropTypes.bool,
};

DownLoadDataContainer.defaultProps = {
  showDLButton: false,
  localLastDate: null,
};

export default DownLoadDataContainer;
